import { createFileRoute } from '@tanstack/react-router';

import { EmailPreviewPage } from '../features/dev/email-preview-page.js';
import { devOnlyGuard } from './-dev-only.js';

export const Route = createFileRoute('/test/emails')({
  beforeLoad: devOnlyGuard,
  component: EmailPreviewPage,
});
